import React from 'react'

export default props => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 70.99 59.45"
    >
        <path
            d="M930.75,567.39V537.9l-3.23,2.66c-.73.6-1.53,1.35-2.35.25-.68-.92,0-1.6.7-2.2,3.66-3,7.28-6.05,11-9a2.52,2.52,0,0,0,1.06-2.21c-.07-4,0-8,0-12v-.88c0-.92.26-1.74,1.3-1.76s1.31.8,1.31,1.74c0,3.27,0,6.54,0,9.81v2.06c1.33-.78,2.43-1.43,2.2-3.21a29.51,29.51,0,0,1,0-4.1c0-.89.45-1.67,1.36-1.5.46.08,1,.94,1.11,1.51a23.21,23.21,0,0,1,0,3.59c3.35-2.77,6.46-5.34,9.56-7.92,1.43-1.18,2.9-2.31,4.27-3.57,1.12-1,2-.93,3.16,0q11.49,9.63,23.07,19.18l9.58,7.94c.3.25.75.46.85.77a8.4,8.4,0,0,1,.23,1.82c-.6,0-1.37.32-1.77.06-1.28-.85-2.42-1.9-3.76-3v29.45h3.25c.86,0,1.55.42,1.31,1.31a1.87,1.87,0,0,1-1.37,1.06c-2.39.11-4.78,0-7.17,0H928.5c-.39,0-.86.13-1.15,0-.48-.26-1.15-.73-1.15-1.11a1.61,1.61,0,0,1,1-1.2A23.57,23.57,0,0,1,930.75,567.39Zm21.43-12c0-3,0-5.88,0-8.76,0-2.22.86-3.11,3.07-3.12,3.47,0,6.93,0,10.4,0,2.4,0,3.22.85,3.22,3.27v8.58h18.81c0-6.44,0-12.78,0-19.12a2,2,0,0,0-.83-1.24q-7.46-6.25-15-12.45l-11.29-9.33c-.37.27-.69.49-1,.73q-12.74,10.56-25.43,21.15a2.53,2.53,0,0,0-.74,1.72c0,5.81,0,11.62,0,17.43,0,.37.07.74.1,1.15Zm2.63-9.26v21h11.45v-21Zm-21.37,21.14H952.1v-9.14H933.44Zm54.19-9.12H969v9.1h18.64Z"
            transform="translate(-924.88 -510.4)"
        />
        <path
            d="M966.54,530.56a6,6,0,1,1-6-6.07A6.13,6.13,0,0,1,966.54,530.56Zm-2.33,0a3.68,3.68,0,1,0-3.72,3.71A3.66,3.66,0,0,0,964.21,530.59Z"
            transform="translate(-924.88 -510.4)"
        />
        <rect x="22.47" y="49.88" width="2.73" height="4.74" rx="1.37" />
        <rect x="16.8" y="49.88" width="2.73" height="4.74" rx="1.37" />
        <rect x="11.14" y="49.88" width="2.73" height="4.74" rx="1.37" />
        <rect x="57.69" y="49.91" width="2.73" height="4.74" rx="1.37" />
        <rect x="52.03" y="49.91" width="2.73" height="4.74" rx="1.37" />
        <rect x="46.37" y="49.91" width="2.73" height="4.74" rx="1.37" />
        <rect x="36.55" y="43.84" width="2.73" height="4.74" rx="1.37" />
    </svg>
)
